import { render } from "./ReviewList.vue?vue&type=template&id=bbab26ca&scoped=true"
import script from "./ReviewList.vue?vue&type=script&lang=js"
export * from "./ReviewList.vue?vue&type=script&lang=js"

import "./ReviewList.vue?vue&type=style&index=0&id=bbab26ca&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbab26ca"]])

export default __exports__